import XTbl, {Xtc} from '../../components/new-x-table/index';
import store from '@/store/store'
let unitsFilter = {}
store.state.contract.units.map((x) => {
    unitsFilter[x.id] = x.value
})
let contractTypes = store.state.contract.contractTypes

const tbl = new XTbl('http://hr.asco-intl.com:2020/kernel/api/personnel/contract/table', 'لیست قرارداد ها');
tbl.add(new Xtc('personnel.proposal.name', 'نام پرسنل').filterText())
tbl.add(new Xtc('personnel.proposal.ncode', 'کد ملی').filterText())
tbl.add(new Xtc('personnel_id', 'کد پرسنلی').filterText())
tbl.add(new Xtc('personnel.proposal.mobile', 'شماره تلفن').filterText())
tbl.add(new Xtc('personnel.proposal.iden_place', 'محل صدور').filterText())
tbl.add(new Xtc('personnel.proposal.birth_place', 'محل تولد').filterText())

tbl.add(new Xtc('salary', 'حقوق پایه').filterText().hidden())
tbl.add(new Xtc('worker_coupon', 'بن کارگری').filterText().hidden())
tbl.add(new Xtc('housing_allowance', 'کمک هزینه مسکن').filterText().hidden())
tbl.add(new Xtc('right_attraction', 'حق جذب').filterText().hidden())
tbl.add(new Xtc('right_guardianship', 'حق سرپرستی').filterText().hidden())
tbl.add(new Xtc('right_child', 'حق فرزند').filterText().hidden())
tbl.add(new Xtc('right_mission', 'حق ماموریت').filterText().hidden())
tbl.add(new Xtc('right_shift', 'حق شیفت').filterText().hidden())
tbl.add(new Xtc('right_try', 'حق السعی').filterText().hidden())
tbl.add(new Xtc('promissory', 'مبلغ سفته').filterText().hidden())
tbl.add(new Xtc('promissory_number', 'شماره سفته').filterText().hidden())
tbl.add(new Xtc('contract_number', 'شماره قرارداد').filterText().hidden())
tbl.add(new Xtc('basic_years', 'پایه سنوات').filterText().hidden())
tbl.add(new Xtc('reward', 'پاداش مستمر').filterText().hidden())
tbl.add(new Xtc('city_workplace', 'محل خدمت').filterText().hidden())
tbl.add(new Xtc('eidi', 'عیدی').filterNumber().hidden())
tbl.add(new Xtc('years', 'علی الحساب سنوات').filterNumber().hidden())
tbl.add(new Xtc('personnel.gender', 'جنسیت').filterSelect({1: 'مرد', 2: 'زن'}).filterKey('personnel.gender').hidden().renderSlot('gender'))
tbl.add(new Xtc('type_str', 'نوع قرارداد').hidden().filterKey('type').filterSelect(contractTypes))
tbl.add(new Xtc('work_unit', 'واحد کار').hidden().renderSlot('work_unit').filterSelect(unitsFilter))
tbl.add(new Xtc('start_atj', 'تاریخ شروع قراداد').filterDate().filterKey('start_at').hidden())
tbl.add(new Xtc('end_atj', 'تاریخ پایان قراداد').filterDate().filterKey('end_at').hidden())

tbl.add(new Xtc('reason_termination', 'دلیل فسخ قرارداد').filterText().hidden())
tbl.add(new Xtc('date_termination', 'تاریخ فسخ قرارداد').filterDate().filterKey('date_termination').hidden())

export default tbl;
